// HOOKS
import { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import useQuery from "../other/useQuery.other.hook";
// GRAPHQL
import { GET_PAYMENT_REPORT } from "../../graphql/queries/payments/payments.queries";
import convertToyyyyMMddThhmm from "../../utils/conversions/dates/yyyyMMddThhmm.date.conversion.util";

const DEFAULT_QUERY = {
  search: "",
  page: 1,
  limit: 0,
  sort: "-created_at",
};
const useGetManyPaymentsReport = () => {
  const [payments, setPayments] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [paymentReportInput, setPaymentReportInput] = useState({});
  const [getPaymentsReport, { loading, error, data }] = useLazyQuery(
    GET_PAYMENT_REPORT,
    {
      fetchPolicy: "no-cache",
    }
  );
  const {
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
  } = useQuery({ defaultQuery: DEFAULT_QUERY });

  const getPaymentReport = async () => {
    try {
      if (!paymentReportInput?.created_at_date_range) return;
      const res = await getPaymentsReport({
        variables: { query, payment: paymentReportInput },
      });
      if (res?.data?.report?.payments)
        setPayments(
          res.data.report.payments.map((payment) => ({
            ...payment,
            created_at: convertToyyyyMMddThhmm(new Date(payment?.created_at)),
          }))
        );
      if (res?.data?.report?.metaData) setMetaData(res.data.report.metaData);
    } catch (error) {
      console.error(`Error getting payments: ${error?.message}`);
      alert(`Error getting payments: ${error?.message}`);
    }
  };

  // Get ROIs on query or roiInput change
  useEffect(() => {
    getPaymentReport();
  }, [query, paymentReportInput]);

  return {
    getPaymentReport,
    payments,
    setPayments,
    metaData,
    setMetaData,
    paymentReportInput,
    setPaymentReportInput,
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading,
    error,
  };
};

export default useGetManyPaymentsReport;
